import React from 'react';
import { FormattedMessage } from 'react-intl';

export const RequestedServiceLabel = () => (
  <FormattedMessage defaultMessage='Requested' description='fulfillmentPlanner.requestedService' id='OkbQYH' />
);
